import { prepareUserData } from '@cian/newbuilding-chat-component';
import { useMemo } from 'react';
import { useSelector } from 'react-redux';

import { getWebimUserDataSelector } from 'shared/selectors/getWebimUserData';
import { accountNameSelector, chatHostSelector, selectLocation } from 'shared/selectors/newbuildingConsultant';

export const useWebimProps = () => {
  const user = useSelector(getWebimUserDataSelector);
  const accountName = useSelector(accountNameSelector);
  const host = useSelector(chatHostSelector);
  const location = useSelector(selectLocation);

  return useMemo(
    () => ({
      accountName: accountName as string,
      userData: prepareUserData(user),
      host: host || undefined,
      location,
    }),
    [accountName, host, location, user],
  );
};
